import { render, staticRenderFns } from "./moneyBack.vue?vue&type=template&id=779d9d5f&scoped=true&"
import script from "./moneyBack.vue?vue&type=script&lang=js&"
export * from "./moneyBack.vue?vue&type=script&lang=js&"
import style0 from "./moneyBack.vue?vue&type=style&index=0&id=779d9d5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779d9d5f",
  null
  
)

export default component.exports